import React from 'react';

import LabelField from '../../../components/plain/LabelField';
import FieldString from '../../../components/plain/FieldString';
import FieldEnum from '../../../components/plain/FieldEnum';
import FieldFile from '../../../components/plain/FieldFile';
import FieldList_CardsPanel from '../../../components/plain/FieldList_CardsPanel';

import DivFileChar from './DivFileChar';

class DivConfirmationList extends React.Component {

	/*
		parentField
		path
		readOnly
		plain
		instance
		ignoreTitle
	*/
	constructor(props) {
		super(props);
	}

	confirmationCardBuilder = (fieldConfirmation, index) => {
		let card = '';

		let name = fieldConfirmation.value.name.value;
		if( name ) {
			card += name;
		}
		
		return card;
	}
	fileCardBuilder = (fieldFileLink, index) => {
		let card = '';
		
		let typeText = fieldFileLink.value.resourceType.value;
		if( typeText )
			card += '[' + typeText + ']; ';
		
		if( fieldFileLink.value.resourceName.value )
			card += fieldFileLink.value.resourceName.value;
			
		if( card.length > 40 )
			card = card.substring(0, 37) + '...'
		return card;
	}
	buildConfirmationPanel = (fieldGroup, listItemInfo) => {
		let plain = this.props.plain;
		let instance = this.props.instance;
		let readOnly = this.props.readOnly;
		return (
			<div style={{flexGrow: '1', backgroundColor: 'lightGray'}}>
				<div style={{margin: '10px', padding: '10px', border: '1px solid gray'}}>

					<div style={{display: 'flex', alignItems: 'center', marginBottom: '15px'}}>
						<FieldString instance={instance} path={'name'} parentField={fieldGroup} plain={plain}
							readOnly={readOnly}
							styles={{ input: {flexGrow: '1'} }}
						/>
					</div>
					<div style={{marginBottom: '15px'}}>
						<FieldList_CardsPanel path={'images'} instance={instance} parentField={fieldGroup} plain={plain}
							readOnly={readOnly}
							labelEmptyToHeader={true}  ignoreTitle={false}
							itemComponent={ConfirmationFilePanel} itemCardBuilder={this.fileCardBuilder}
							styles={{
								divCardsBlock: {
									marginRight: '10px',
									backgroundColor: 'lightGray',
									minWidth: '200px',
									padding: '0'
								},
								divCard: {
									marginTop: '3px',
									padding: '7px',
									cursor: 'pointer',
									backgroundColor: 'lightGray',
									minHeight: '18px'
								}
							}}
						/>
					</div>

					<LabelField instance={instance} path={'comment'} parentField={fieldGroup} />
					<div style={{display: 'flex', flexGrow: '1'}}>
						<FieldString instance={instance} path={'comment'} parentField={fieldGroup} plain={plain}
							readOnly={readOnly}
							multiline={true} rows={4} cols={60}
							styleInput={{flexGrow: '1'}} ignoreTitle={true}
						 />
					</div>
				</div>
			</div>
		);
	}

	render() {
		let path = this.props.path;
		let readOnly = this.props.readOnly;
		let plain = this.props.plain;
		let instance = this.props.instance;
		let parentField = this.props.parentField;
		let ignoreTitle = this.props.ignoreTitle;
		if( ! parentField ) {
			parentField = instance.rootField;
		}
		return (
			<FieldList_CardsPanel path={path} instance={instance} plain={plain} parentField={parentField} readOnly={readOnly}
				buildItemComponent={this.buildConfirmationPanel} itemCardBuilder={this.confirmationCardBuilder}
				ignoreTitle={ignoreTitle} labelEmptyToHeader={true}
				styles={{
					divCardsBlock: {
						marginRight: '3px',
						backgroundColor: 'rgb(240,240,240)',
						minWidth: '200px'
					},
					divCard: {
						marginTop: '3px',
						padding: '7px',
						cursor: 'pointer',
						backgroundColor: 'lightGray',
						minHeight: '18px'
					}
				}}
			/>
		);
	}
}

class ConfirmationFilePanel extends React.Component {

	/*
		plain
		instance
		fieldGroup
		listItemInfo
		readOnly
	*/
	constructor(props) {
		super(props);
	}
	
	render() {
		let fieldGroup = this.props.fieldGroup;
		let plain = this.props.plain;
		let instance = this.props.instance;
		let readOnly = this.props.readOnly;
		return (
			<div style={{flexGrow: '1', backgroundColor: 'rgb(230, 230, 230)'}}>
				<div style={{margin: '10px', padding: '10px', border: '1px solid gray'}}>
					<div style={{display: 'flex', alignItems: 'center', marginBottom: '15px'}}>
						<FieldEnum instance={instance} path={'resourceType'} parentField={fieldGroup} plain={plain}
							readOnly={readOnly}
							styles={{select: {width: '150px', marginRight: '20px'}}}
						 />
						<FieldString instance={instance} path={'resourceName'} parentField={fieldGroup} plain={plain}
							readOnly={readOnly}
							styleInput={{flexGrow: '1'}}
						 />
					</div>
					<div style={{display: 'flex', alignItems: 'center', marginBottom: '15px'}}>
						<FieldString instance={instance} path={'resourceURI'} parentField={fieldGroup} plain={plain}
							readOnly={readOnly}
							styles={{ divMain: {flexGrow: '1'}}}
						 />
					</div>
					<DivFileChar instance={instance} fieldGroup={fieldGroup} plain={plain}
						readOnly={readOnly}
						styles={{ divMain: {marginBottom: '15px'} }} 
					/>
					<div style={{display: 'flex', alignItems: 'center', marginBottom: '15px'}}>
						<FieldFile instance={instance} path={'resourceFile'} parentField={fieldGroup} plain={plain}
							readOnly={readOnly}
							styleDiv={{flexGrow: '1'}}
						 />
					</div>
				</div>
			</div>
		)
	}
}

export default DivConfirmationList;
